module.exports = __webpack_public_path__ + "img/chevron-forward-primary.dbc26a3e.svg";